/**
 * Created by calhosh on 7/16/2017.
 */

import React from 'react';
import NotificationSystem from 'react-notification-system';
import connect from 'react-redux-connect';
import {bindActionCreators} from 'redux';
import {labels, currentResource} from '../../utils/utils';
import * as errorActions from '../../errors';
import {findDOMNode} from 'react-dom';
import $ from 'jquery';
import _, {isEqual} from 'lodash';
import styled, {css} from 'styled-components';
import {minorErrorCodes} from '../../utils/uiconstants';

const StyledErrors = styled.div`
	.notifications-wrapper {
		.notifications-tc {
			width: calc(100vw - 8rem) !important;
			top: 6rem !important;
			left: 4rem !important;
			margin: 2px 0 0 0 !important;
			padding: 0 !important;
			z-index: 10000 !important;

			.notification {
				margin: 0 !important;
				padding: 0px !important;
				border: 1px solid ${(props) => props.theme.color[`grey300`]} !important;
				height: auto !important;
				margin-bottom: 2px !important;
				box-shadow: 1px 1px 4px ${(props) => props.theme.color[`grey300`]} !important;
				background: ${(props) => props.theme.color[`white`]} !important;
				width: calc(100% - 1.3rem) !important;

				&.notification-error,
				&.notification-success {
					background: ${(props) => props.theme.color[`white`]} !important;
				}

				.notification-message {
					padding: 0 !important;
					max-height: 60vh;
					overflow: auto;
					color: ${(props) => props.theme.color[`grey500`]} !important;
					display: table;
					width: calc(100% - 30px);
					font-size: 1.2rem;
					line-height: 18px;

					.error-message {
						display: table-cell;
						padding: 9px 10px 5px;
						color: ${(props) => props.theme.color[`grey500`]};
						background: ${(props) => props.theme.color[`white`]} !important;
					}
				}

				.notification-dismiss {
					background-color: transparent !important;
					top: 12px !important;
					right: 14px !important;
					color: ${(props) => props.theme.color[`grey500`]} !important;
					font-size: 20px !important;
					font-weight: normal !important;
				}
			}
		}
	}
`;

class Errors extends React.Component {
	static mapStateToProps(store) {
		let errors = store.errors,
			isModalOpen = store.isModalOpen;
		return {
			errors,
			isModalOpen
		};
	}

	static mapDispatchToProps(dispatch) {
		return {
			actions: bindActionCreators(Object.assign({}, errorActions), dispatch)
		};
	}
	static getErrorCodeValue(errorCodes) {
		let errors = [];
		/*User = 1000 - 2000*/

		if (errorCodes.length > 0) {
			for (let i = 0; i < errorCodes.length; i++) {
				errors.push(
					'<strong>' +
						errorCodes[i] +
						': ' +
						'</strong>' +
						currentResource.errors[errorCodes[i]]
				);
			}
			return errors;
		} else return errorCodes;
	}

	static errorCountDisplay(errors) {
		let errorCount = 0;
		let error;
		let message = '';

		try {
			error = JSON.parse(errors);
		} catch (err) {
			message = errors;
		}

		if (error) {
			if (error.ErrorCode) {
				errorCount = 1;
			} else {
				errorCount = error.length;
			}
		} else {
			errorCount = 1;
		}

		return labels.errorBanner
			? labels.errorBanner.replace('{0}', errorCount)
			: '';
	}

	constructor(props) {
		super(props);
		this.state = {
			style: {
				//custom notification styles
				NotificationItem: {
					//override the notification item
					DefaultStyle: {
						margin: '10px 5px',
						padding: '0'
					}
				}
			},
			allowHTML: true
		};

		_.bindAll(this, ['clearErrors']);
	}

	isMinorError = (errorMessage) => {
		if (!_.isEmpty(errorMessage) && typeof errorMessage === 'string') {
			let errorCode = errorMessage.substr(0, 4);
			return minorErrorCodes.some(
				(minorError) => parseInt(errorCode) === minorError
			);
		}
		return false;
	};

	componentDidMount() {
		this.notificationSystem = this.refs.notificationSystem;
		if (
			this.props.errors &&
			this.props.errors.length > 0 &&
			!this.isMinorError(this.props.errors)
		) {
			let level = this.props.errors.level ? this.props.errors.level : 'error';
			let message = this.props.errors.message
				? this.props.errors.message
				: this.errorMessages(this.props.errors);
			this.notificationSystem.addNotification({
				message:
					'<span class="' +
					level +
					'-icon"></span> <span class="error-message">' +
					message +
					'</span>',
				level: level,
				position: 'tc', //top center
				autoDismiss: 0, //dont autodismiss
				onRemove: this.clearErrors,
				dismissible: 'button'
			});
		}
	}

	componentWillReceiveProps(nextProps) {
		if (isEqual(this.props?.errors, nextProps?.errors)) {
			return;
		}

		if (!nextProps.isModalOpen) {
			if (Array.isArray(nextProps.errors)) {
				if (
					nextProps.errors.length > 0 &&
					!this.isMinorError(nextProps.errors)
				) {
					let level = nextProps.errors.level ? nextProps.errors.level : 'error';
					let message = nextProps.errors.message
						? nextProps.errors.message
						: this.errorMessages(nextProps.errors);
					this.notificationSystem.addNotification({
						message:
							'<span class="' +
							level +
							'-icon"></span> <span class="error-message">' +
							message +
							'</span>',
						level: level,
						position: 'tc', //top center
						autoDismiss: 0, //dont autodismiss
						onRemove: this.clearErrors,
						dismissible: 'button'
					});
				}
			} else {
				if (
					_.keys(nextProps.errors).length > 0 &&
					!this.isMinorError(nextProps.errors)
				) {
					let level = nextProps.errors.level ? nextProps.errors.level : 'error';
					let message = nextProps.errors.message
						? nextProps.errors.message
						: this.errorMessages(nextProps.errors);

					if (message === 'Network Error') {
						message = labels.NetworkErrorMessage;
					}
					this.notificationSystem.addNotification({
						message:
							'<span class="' +
							level +
							'-icon"></span> <span class="error-message">' +
							message +
							'</span>',
						level: level,
						position: 'tc', //top center
						autoDismiss: 0, //dont autodismiss
						onRemove: this.clearErrors,
						dismissible: 'button'
					});
				}
			}
		}
	}

	shouldComponentUpdate(nextprops, nextstate) {
		if (nextprops.isModalOpen) return false;
		else return true;
	}

	componentDidUpdate() {
		this.notificationSystem = this.refs.notificationSystem;
		if (this.notificationSystem) {
			let closeObj = findDOMNode(this.notificationSystem);
			let close = $(closeObj).find('.notification-dismiss');
			if (close.length > 0) {
				close.attr('title', labels.closeLabel);
			}
		}
	}

	errorMessages(errors) {
		let errorCodes = [];
		let errorMessages = [];
		let error;
		let message = '';
		let errorMessage = '';

		try {
			if (errors.indexOf(' - ') > 0) {
				error = errors.substr(0, errors.indexOf(' -'));
			} else {
				error = JSON.parse(errors);
			}
		} catch (err) {
			message = errors;
		}

		if (error) {
			if (error.length > 0 && Array.isArray(error)) {
				error.map((error) => {
					if (error.ErrorCode) {
						errorCodes.push(error.ErrorCode);
					} else {
						errorMessages.push(error.Message);
					}
				});
			} else {
				if (error.ErrorCode) {
					errorCodes.push(error.ErrorCode);
				} else {
					errorCodes.push(Number(error));
				}
			}

			if (errorCodes.length !== 0) {
				errorMessages = Errors.getErrorCodeValue(errorCodes);
				if (errorMessages.length > 0) {
					errorMessages.map((message) => {
						errorMessage += '<div>' + message + '</div>';
					});
					return errorMessage;
				}
			}

			if (errorMessages.length > 0) {
				errorMessages.map((message) => {
					errorMessage += '<div>' + message + '</div>';
				});
				return errorMessage;
			}
		} else {
			return message;
		}
	}

	clearErrors() {
		this.props.actions.clearErrors();
	}

	render() {
		return (
			<StyledErrors>
				<NotificationSystem ref="notificationSystem" allowHTML />
			</StyledErrors>
		);
	}
}

export default connect(Errors);
